module.exports = __webpack_public_path__ + "img/bg-videos.626b78d4.webp";